import React, { Fragment } from "react";
import { connect } from "react-redux";
import "./Home.scss";

// prop-types
import PropTypes from "prop-types";
import userPropTypes from "../../propTypes/userPropTypes";

// routes
import Routes from "../../constants/Routes";

// components
import withRouter from "../../coraWebComponents/utils/withRouter";
import { buildUrl } from "../../coraWebComponents/utils/helper";
import Button from "../../coraWebComponents/buttons/Button";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";
import Dialog from "../../coraWebComponents/dialogs/Dialog";
import ManualPDF from "../../coraWebComponents/navigation/ManualPDF";

// actions
import * as appHeaderActions from "../../actions/appHeaderActions";
import * as manualsActions from "../../actions/manualsActions";
import * as tablesActions from "../../actions/tablesActions";

const _AA_DEF_OB_ID = "1000007";
class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isManualDialogOpen: false,
    };

    const pathToAssets = "assets/";
    this.cardsData = {
      rows: [
        {
          cards: [
            {
              altImage: "Zmluvy",
              cardTitle: "Zmluvy",
              cssClasses: "zmluvy",
              imgSrc: buildUrl(pathToAssets + "zis_portal_dash_zmluvy.svg"),
              route: Routes.ZMLUVY,
              title:
                "Zobrazujú sa všetky platné zmluvy, ktoré má s vodárňou podpísané aktuálne vybraný odberateľ",
            },
            {
              altImage: "OdberneMiesta",
              cardTitle: "Odberné miesta",
              cssClasses: "odberneMiesta",
              imgSrc: buildUrl(pathToAssets + "zis_portal_dash_uhrady.svg"),
              route: Routes.ODBERNE_MIESTA,
              title: "Zobrazujú sa všetky odberné miesta pre vybranú zmluvu.",
            },
          ],
        },
        {
          cards: [
            {
              altImage: "Faktury",
              cardTitle: "Faktúry",
              cssClasses: "faktury",
              imgSrc: buildUrl(pathToAssets + "zis_portal_dash_faktury.svg"),
              route: Routes.FAKTURY,
              title:
                "Zobrazujú sa všetky faktúry, ktoré boli vystavené pre vybrané odberné miesto",
            },
            {
              altImage: "Spotreba",
              cardTitle: "Spotreba",
              cssClasses: "spotreba",
              imgSrc: buildUrl(pathToAssets + "zis_portal_dash_spotreba.svg"),
              route: Routes.SPOTREBA,
              title:
                "Graf spotreby zobrazuje vývoj spotreby na vybranom odbernom mieste po obdobiach definovaných v zmluve",
            },
          ],
        },
      ],
    };
    this.questions = [
      `<a href="#${Routes.KONTAKTNE_UDAJE}">
        Kde si môžem zmeniť <b>kontaktné údaje</b>?
      </a>`,
      `<a href="#${Routes.FORM_ADD_ODBERATEL}">
        Chcem si pridať ďalšieho <b>odberateľa</b>.
      </a>`,
    ];
  }

  // DIALOG METHODS
  handleOpenManualDialog = (e) => {
    e.preventDefault();
    this.setState({ isManualDialogOpen: true });
  };
  handleManualDialogClose = () => {
    this.setState({
      isManualDialogOpen: false,
    });
  };

  // METHODS
  genChildren = () => {
    const { user, getManual, manualBlob, manualFileName, isLoading } =
      this.props;

    return (
      <>
        <LoadingPanel isLoading={isLoading} />
        <ManualPDF
          manualProps={{
            hasList: false,
            user,
            manualBlob,
            manualFileName,
            manualTitle: "ZISportal_prirucka",
          }}
          getManual={getManual}
        />
      </>
    );
  };
  contactZakCentrum = (e) => { };

  // SYSTEM METHODS
  componentDidMount = () => {
    const { showAppHeader, changeHeaderTitle, getAA_DEF_OB_HODN } = this.props;

    showAppHeader(false);
    changeHeaderTitle("");

    getAA_DEF_OB_HODN(_AA_DEF_OB_ID);
  };
  render() {
    const { isLoading, aaDefOB } = this.props;

    const AA_DEF_OB_HODN = aaDefOB ? aaDefOB.split("") : [];
    return (
      <div className="row m-0" style={{ height: "100%" }}>
        <div className="col p-4">
          {/* Title */}
          <div className="row m-0">
            <div className="col p-0 homeTitle">
              Zákaznícky informačný portál pre odberateľov
            </div>
          </div>
          <div className="row m-0 pt-5">
            <div className="col p-0">
              Služba poskytuje online informácie o spotrebe tepla na vykurovanie
              ÚK a prípravu TÚV, umožňuje prehliadať a sťahovať faktúry.
              <br />
              Viac informácií alebo spôsob používania portálu nájdete v{" "}
              <a href={`#${Routes.HOME}`} onClick={this.handleOpenManualDialog}>
                metodických postupoch
              </a>
              .
            </div>
          </div>

          {/* BODY */}
          <div className="row m-0 pt-5">
            {/* CARDS */}
            <div className="col-sm p-0 cards-container">
              {this.cardsData.rows.map((row, cardRowKey) => {
                /* ITER ROWS */
                return (
                  <div
                    className="row m-0 row-in-cards-container"
                    key={cardRowKey}
                  >
                    {row.cards.map((card, cardKey) => {
                      /* ITER CARDS IN ROWS */
                      return (
                        <div className="col p-1" key={cardKey}>
                          <a
                            title={card.title}
                            href={`#${card.route}`}
                            className="a-card-link"
                          >
                            <div className={`card-home ${card.cssClasses}`}>
                              <div className="card-content">
                                <img
                                  className="card-content-image"
                                  src={card.imgSrc}
                                  alt={card.altImage}
                                />
                                <div className="card-content-text">
                                  {card.cardTitle}
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
            {/* Questions */}
            <div className="col-sm p-0 questions-container">
              <div className="row m-0 questions">
                <div className="col">
                  <ul className="home">
                    {this.questions.map((q, qKey) => {
                      const renderQuestion =
                        AA_DEF_OB_HODN.length !== 0 &&
                        AA_DEF_OB_HODN[qKey] === "1";

                      return (
                        <Fragment key={qKey}>
                          {renderQuestion && (
                            <li
                              className="question"
                              dangerouslySetInnerHTML={{ __html: q }}
                            />
                          )}
                        </Fragment>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* FOOTER */}
          {AA_DEF_OB_HODN.length !== 0 && AA_DEF_OB_HODN[2] === "1" && (
            <div className="row m-0 homeFooter">
              <div className="col-sm p-2 homeFooterText">
                <span>Nenašli ste odpoveď na vaše otázky?</span>
              </div>
              <div className="col-sm p-2 homeFooterButton">
                <Button
                  label="Kontaktujte zákaznícke centrum"
                  className="homeContactButton"
                  onClick={this.contactZakCentrum}
                />
              </div>
            </div>
          )}
        </div>

        {/* METODICKE POSTUPY */}
        <Dialog
          isOpen={this.state.isManualDialogOpen}
          title={"Používateľská príručka"}
          onClose={this.handleManualDialogClose}
          onConfirm={this.handleManualDialogClose}
          fullscreen={true}
          className={"fullscreen-report"}
          children={this.genChildren()}
        />
        <LoadingPanel isLoading={isLoading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    aaDefOB: state.aaDefOB.data,
    isLoading: state.manual.isLoading,
    manualBlob: state.manual.file ? state.manual.file.blob : null,
    manualFileName:
      state.manual.file && state.manual.file.fileName
        ? state.manual.file.fileName
        : "ZISportal_prirucka.pdf",
    user: state.user.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getAA_DEF_OB_HODN: (id) => dispatch(tablesActions.getAA_DEF_OB_HODN(id)),
  getManual: () => dispatch(manualsActions.getManual()),
  changeHeaderTitle: (title) =>
    dispatch(appHeaderActions.changeHeaderTitle(title)),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
});

Home.propTypes = {
  aaDefOB: PropTypes.string,
  getAA_DEF_OB_HODN: PropTypes.func,
  getManual: PropTypes.func,
  changeHeaderTitle: PropTypes.func,
  isLoading: PropTypes.bool,
  manualBlob: PropTypes.object,
  manualFileName: PropTypes.string,
  showAppHeader: PropTypes.func,
  user: userPropTypes.user,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
